import React, { useState, useEffect, useRef } from 'react'
import { setConfig } from 'react-hot-loader'
import { getToken } from 'api/request'

setConfig({ pureSFC: true })

export const AccessTokenContext = React.createContext()

const AccessTokenProvider = ({ children }) => {
  const [token, setToken] = useState(null)
  const [loading, setLoading] = useState(true)
  let isMounted = useRef(false)
  useEffect(() => {
    isMounted.current = true
    getToken()
      .then(token => {
        if (isMounted.current) {
          setToken(token)
        }
      })
      .then(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
      .catch(err => console.log('err', err))
    return () => {
      isMounted.current = false
    }
  }, [])

  return (
    <AccessTokenContext.Provider value={{ token, loading }}>
      {children}
    </AccessTokenContext.Provider>
  )
}

export default AccessTokenProvider
